import { render, staticRenderFns } from "./Chi_twoColumnSection.vue?vue&type=template&id=a0e7fc44&scoped=true"
import script from "./Chi_twoColumnSection.vue?vue&type=script&lang=ts"
export * from "./Chi_twoColumnSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e7fc44",
  null
  
)

export default component.exports